module.exports = __webpack_public_path__ + "static/img/licesence-04.ab9c9cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/licesence-04.jpg
// module id = VlCQ
// module chunks = 1